module.exports = __webpack_public_path__ + "static/media/contact.6d0a1710.png";